// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gantt-chart {\n  margin-bottom: -50px;\n  -webkit-font-smoothing: antialiased;\n  --gantt-chart-offset-top: 200px; }\n  @media (max-width: 768px) {\n    .gantt-chart {\n      --gantt-chart-offset-top: 119px; } }\n  .gantt-chart__scale-unit {\n    display: flex;\n    justify-content: flex-end; }\n    .gantt-chart__scale-unit .unit_btn_wrap {\n      float: initial; }\n", ""]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader/dist/cjs.js!../node_modules/sass-loader/lib/loader.js!./Src/Components/Schedule/GanttChart.scss
// module id = 4487
// module chunks = 1